module.exports = __webpack_public_path__ + "img/busca-avancada-ingenieros.719f9fd8.jpg";